import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import { ISmsDeliveryErrorGetParams, ISmsDeliveryErrorResponse, Resources } from '../types'

export class SmsDeliveryErrorResource extends GenericResource<ISmsDeliveryErrorResponse, any, any, any> {
  public del = this.buildDel()
  constructor(agent: IHttpAgent) {
    super(Resources.SmsDeliveryError, agent)
  }

  public async get(params: ISmsDeliveryErrorGetParams): Promise<ISmsDeliveryErrorResponse> {
    const { data } = await this.agent.get<ISmsDeliveryErrorResponse>(`${this.resource}`, { params })
    return data
  }
}
